import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { trackPageView } from '@/lib/googleAnalytics'
import { useCookieConsentStore } from '@/stores/cookie-consent.store'

export function PageViewTracker(): null {
  const location = useLocation()
  const analytics = useCookieConsentStore((state) => state.preferences.analytics)
  const decided = useCookieConsentStore((state) => state.decided)

  useEffect(() => {
    if (decided && analytics) {
      trackPageView(location.pathname + location.search)
    }
  }, [location.pathname, location.search, analytics, decided])

  return null
}
